var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprisePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 46,
    viewBox: "0 0 43 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 39506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.8294 33.7646L42.8387 33.7595H42.8206L32.1943 28.0015L21.5504 22.2334L10.9061 28.0015L0.279801 33.7595H0.261719L0.27097 33.7646L0.261719 33.7696H0.279801L10.9061 39.5276L21.5504 45.2957L32.1943 39.5276L42.8206 33.7696H42.8387L42.8294 33.7646Z",
    fill: "#C1E5EC",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.8294 11.6493L42.8387 11.6447H42.8206L32.1943 5.88627L21.5504 0.118164L10.9061 5.88627L0.279801 11.6447H0.261719L0.27097 11.6493L0.261719 11.6544H0.279801L10.9061 17.4128L21.5504 23.1809L32.1943 17.4128L42.8206 11.6544H42.8387L42.8294 11.6493Z",
    fill: "#23A6BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.279297 11.1807V34.2333L21.5499 22.7072L0.279297 11.1807Z",
    fill: "#C1E6EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.821 11.1807V34.2333L21.5508 22.7072L42.821 11.1807Z",
    fill: "#C1E6EC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlan);
export default __webpack_public_path__ + "static/media/enterprise_plan.729843bfecb89304521c66248e787cb0.svg";
export { ForwardRef as ReactComponent };